module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Wine-034350ccec3a75cc186025d60277edd8.svg";